export default __webpack_public_path__ + "static/media/software.b646dadb.svg";